import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../../redux/reducers/rootReducer";
import { ICorrespondence } from "../../../interfaces/Correspondence";
import { arraySearch } from "../../../redux/actions/searchActions";
import { CommunicationChannels } from "../../../enums/enums";

function useCitizenForm() {
  const dispatch = useDispatch();
  const [correspondenceFilter, setCorrespondenceFilter]: any = useState();

  const { correspondence } = useSelector(
    (state: AppState) => state.correspondence
  );

  const isPqrs = (item: ICorrespondence) => {
    const id = item.id.slice(0, 2);

    return item.isGiveBack && id === CommunicationChannels.WEB_FORM;
  };

  useEffect(() => {
    const data = correspondence.filter((item) => isPqrs(item));
    setCorrespondenceFilter(data);
    dispatch(arraySearch(data));
  }, [correspondence, dispatch]);

  return { correspondenceFilter };
}

export default useCitizenForm;
